<template>
  <div
    class="MessageBox"
    :class="[{ Open: isVisible }, options.type]"
    ref="MessageBox"
  >
    <div class="MessageBoxBlock">
      <div class="MessageBoxTitle">
        <div class="MessageBoxTitleText">{{ options.title }}</div>
        <!-- <div class="MessageBoxClose">
          <a class="MessageBoxCloseButton fa fa-times-circle-o" @click="hide(null)"></a>
        </div>-->
      </div>
      <div class="MessageBoxBody">
        <div class="MessageBoxIcon">
          <span
            class="fa fa-exclamation-triangle"
            v-if="options.type == 'info'"
          ></span>
          <span
            class="fa fa-times-circle"
            v-if="options.type == 'error'"
          ></span>
          <span
            class="fa fa-question-circle"
            v-if="options.type == 'confirm'"
          ></span>
          <span
            class="fa fa-check-circle"
            v-if="options.type == 'success'"
          ></span>
        </div>
        <div class="MessageBoxMessage" v-html="options.message"></div>
      </div>
      <div class="MessageBoxButtons">
        <input
          type="button"
          v-for="actionButton in buttonActions"
          :key="actionButton.buttonName"
          @click="hide(actionButton)"
          :value="actionButton.buttonName"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      isVisible: false,
      options: {},
      buttonActions: [],
      targetButton: null,
    };
  },
  methods: {
    show(message, ...buttonActions) {
      if (event) {
        this.targetButton = event.target;
      }
      let options = {};

      if (typeof message == "string") {
        options.title = "Message Box";
        options.message = message;
        options.type = "";
        options.defaultButton = 1;
      } else {
        options.title = message.title || "Message Box";
        options.message = message.message || options.msg || "";
        options.type = message.type || "info";
        options.defaultButton = message.defaultButton || 1;
        if (!message.title) {
          switch (options.type.toLowerCase()) {
            case "info":
              options.title = "Information Box";
              break;
            case "error":
              options.title = "Error Box";
              break;
            case "confirm":
              options.title = "Confirmation Box";
              break;
            case "success":
              options.title = "Success Box";
              break;
          }
        }
      }
      options.type = options.type.toLowerCase();
      this.options = options;
      this.buttonActions = buttonActions;
      this.isVisible = true;
      this.$emit("show", this);
      if (this.buttonActions.length == 0) {
        this.buttonActions = [{ buttonName: "OK" }];
      }
      let MessageBox = this.$refs.MessageBox;
      let _defaultButton = options.defaultButton;
      window.setTimeout(function () {
        let defaultButton = MessageBox.querySelector(
          "input:nth-child(" + _defaultButton + ")"
        );
        if (defaultButton) {
          defaultButton.focus();
        }
      });
    },
    hide(actionButton) {
      this.isVisible = false;
      this.$emit("hide", actionButton);
      let _targetButton = this.targetButton;
      window.setTimeout(function () {
        if (_targetButton && _targetButton.focus) {
          _targetButton.focus();
        }
      });

      if (actionButton) {
        if (actionButton.buttonAction) {
          if (typeof actionButton.buttonAction == "function") {
            window.setTimeout(function () {
              actionButton.buttonAction();
            }, 100);
          }
        }
      }
    },
  },
};
</script>
<style>
.MessageBox {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  opacity: 0;
  transform: scale(0);
  transition: all 200ms ease-in-out;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.MessageBox.Open {
  opacity: 1;
  transform: scale(1);
}
.MessageBox .MessageBoxBlock {
  position: absolute;
  border: solid 1px black;
  border-radius: 5px;
  padding: 1px;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin-top: -100px;
}
.MessageBox .MessageBoxBlock .MessageBoxTitle {
  flex-grow: 0;
  flex-shrink: 0;
  background-color: rgba(0, 0, 30, 0.9);
  color: white;
  display: flex;
  padding: 5px;
  font-size: 120%;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}
.MessageBox .MessageBoxBlock .MessageBoxTitle .MessageBoxTitleText {
  flex-grow: 1;
  flex-shrink: 1;
}
.MessageBox .MessageBoxBlock .MessageBoxTitle .MessageBoxClose {
  flex-grow: 0;
  flex-shrink: 0;
}
.MessageBox
  .MessageBoxBlock
  .MessageBoxTitle
  .MessageBoxClose
  .MessageBoxCloseButton {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: normal;
  font-size: 120%;
  top: -2px;
  margin-left: 20px;
  position: relative;
}
.MessageBox .MessageBoxBlock .MessageBoxBody {
  padding: 10px;
  min-width: 300px;
  min-height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.MessageBox .MessageBoxBlock .MessageBoxBody .MessageBoxIcon {
  font-size: 400%;
  margin: 10px;
  flex-grow: 0;
  flex-shrink: 0;
}
.MessageBox .MessageBoxBlock .MessageBoxBody .MessageBoxMessage {
  font-weight: normal;
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}
.MessageBox .MessageBoxBlock .MessageBoxButtons {
  text-align: center;
  padding: 10px;
}
.MessageBox .MessageBoxBlock .MessageBoxButtons input[type="button"] {
  padding: 7px 10px;
  border: solid 1px transparent;
}
.MessageBox .MessageBoxBlock .MessageBoxButtons input[type="button"]:focus {
  border: solid 1px black;
  outline: dotted 1px gray;
}
.MessageBox .MessageBoxBlock .MessageBoxButtons input[type="button"]:active {
  border: solid 2px black;
}
.MessageBox .MessageBoxBlock {
  background-color: white;
  color: black;
}

.MessageBox.info .MessageBoxBlock {
  background-color: white;
  color: rgb(0, 6, 190);
}
.MessageBox.info .MessageBoxIcon {
  color: blue;
}
.MessageBox.error .MessageBoxBlock {
  background-color: rgb(255, 240, 240);
  color: red;
}
.MessageBox.error .MessageBoxIcon {
  color: red;
}
.MessageBox.confirm .MessageBoxBlock {
  background-color: rgb(253, 245, 190);
  color: black;
}
.MessageBox.confirm .MessageBoxIcon {
  color: orange;
}
.MessageBox.success .MessageBoxBlock {
  background-color: rgb(190, 253, 195);
  color: rgb(17, 68, 26);
}
.MessageBox.success .MessageBoxIcon {
  color: rgb(9, 156, 65);
}
</style>



// WEBPACK FOOTER //
// src/components/ekkControls/MessageBox.vue